module.exports = __webpack_public_path__ + "static/media/breastSurgery-image2@2x.27f07d5b.png";